import dayjs from 'dayjs';

import { doRequest } from '@r1-frontend/do-request';
import getPaymentsPeriodStructure from '@r1-frontend/api-domru/api-profile/v1/payments/period-structure';

/**
 * @param {Object} viewDate 22.10.2020
 * @returns {Promise<{
 *     GetTime: string,
 *     DateFrom: string,
 *     DateTo: string,
 *     HeaderInfo: {
 *         AgrPayTypeName: string,
 *         AgrDate: string
 *     },
 *     PeriodCharges: object,
 *     PeriodPayments: object
 * }>}
 */
export const getPeriodData = async(viewDate: Date) => {
    const innerDate =  (viewDate instanceof Date) ? dayjs(viewDate).format('DD.MM.YYYY') : viewDate;

    const resp = await doRequest.apiProfile<unknown>(
        getPaymentsPeriodStructure({ date_from: innerDate, newApi: true }),
    );

    if (resp.isSuccess) {
        // @ts-ignore
        return resp.payload?.data?.result.GetPeriodStructure;
    }
};

